import {
    IDashboardCorretorVendasResponse,
    IListarComprovantesUsuarioRequest,
    IListarComprovantesUsuarioResponse,
    IListarUsuarioVendasReponse,
    IPerfilUsuario,
} from "../../../Interfaces/Vendas/Usuario/UsuarioInterface";
import AxiosVendas from "../../Config/ApiVendas";
import Service from "../../Service";

export async function ListarUsuariosVendasService() {
    return Service(
        AxiosVendas.get<Array<IListarUsuarioVendasReponse>>(
            `/app/usuario/listarusuarios`
        )
    );
}

export async function ListarUsuariosPorEquipeVendasService(
    ID_EQUIPE_VENDAS: number
) {
    return Service(
        AxiosVendas.get<Array<IListarUsuarioVendasReponse>>(
            `/app/usuario/listarusuarioscommesmaequipedevendas?ID_EQUIPE_VENDAS=${ID_EQUIPE_VENDAS}`
        )
    );
}

export async function ListarPerfilUsuarioVendasService() {
    return Service(
        AxiosVendas.get<Array<IPerfilUsuario>>(
            `/app/usuario/listarperfilusuario`
        )
    );
}

export async function ListarCompromissosUsuarioService<
    TResponseType extends Array<IListarComprovantesUsuarioResponse> | Blob
>(exportExcel: boolean, requestBody: IListarComprovantesUsuarioRequest) {
    return Service(
        AxiosVendas.post<TResponseType>(
            `/app/usuario/listarcompromissosusuario?exportExcel=${exportExcel}`,
            requestBody,
            { responseType: exportExcel ? "blob" : "json" }
        )
    );
}

export async function DashboardCorretorVendasService(
    ID_TIPO_ATIVIDADE: number,
    ID_EMPREENDIMENTO: number,
    DT_INICIO: string,
    DT_FIM: string
) {
    return Service(
        AxiosVendas.get<Array<IDashboardCorretorVendasResponse>>(
            `/app/usuario/dashboardcorretor?ID_TIPO_ATIVIDADE=${ID_TIPO_ATIVIDADE}&ID_EMPREENDIMENTO=${ID_EMPREENDIMENTO}&DT_INICIO=${DT_INICIO}&DT_FIM=${DT_FIM}`
        )
    );
}
